module.exports = __webpack_public_path__ + "media/images/admin/magazines/icon_balloon-3975c737b346826d5ce79b08ef12a167.png";